export default "__VITE_ASSET__D4EUt52q__"